define('LNRS/Track/DataLayerManager',["jquery", "Track/GoalsManager"], function ($, gmanager) {

    function DataLayerManager() {
        var isReadyDef = $.Deferred(), isSnippetPreview = $(".score-snippet-edit-container").length > 0;

        Object.defineProperties(this, {
            isReady: {
                get: function () {
                    return isReadyDef.promise();
                }
            }
        });

        this.dataLayerReady = function dataLayerReady() {
            if (isReadyDef.state() !== "pending") {
                throw new Error("Data Layer initialized multiple times");
            }

            isReadyDef.resolve();
        };

        this.trackAnalytics = function trackAnalytics(o) {
            gmanager.triggerGoal(o);

            // Sort the handraiser array alphabetically if it exists
            if (Array.isArray(o.handraiser)) {
                o.handraiser.sort();
            }

            console.log("Track Analytics\n" + JSON.stringify(o, null, 4));
            window.digitalData.push(o);           
        };

        this.trackVWOEvents = function trackAnalytics(o, eventName) {
            // Do not change anything in the following two lines
            window.VWO = window.VWO || [];
            VWO.event = VWO.event || function () { VWO.push(["event"].concat([].slice.call(arguments))) };

            // Replace the property values with your actual values
            if (window.VWO) {
                console.log("Track VWO Events\n" + JSON.stringify(o, null, 4));
                VWO.event(eventName, o);
            }            
        };

        this.trackVWOEloquaFormSubmission = function ($formInstance, isSuccess) {
            window.VWO = window.VWO || [];
            var successFlag = isSuccess ? 1 : 0;
            window.VWO.push(['nls.formAnalysis.markSuccess', $formInstance[0], successFlag]);

            // Log tracking info
            var submissionId = $formInstance.find('[name="SubmissionId"]').val();

            console.log("Tracking Eloqua form submission in VWO.");
            console.log("Submission success: ", isSuccess);
            console.log("Form Name: ", $formInstance.attr('name'));
            console.log("Submission ID: ", submissionId);
        };
    }

    return new DataLayerManager();
});
